import React from 'react';
import { Modal, XFilledIcon, Grid, Button } from "react-unity";

export interface TrashcanModalProps {
	onRemove: () => any;
	onDelete: () => any;
    onClose: () => any;
	deleteNew: boolean;
}

const TrashcanModal = (trashcanModalProps: TrashcanModalProps) => {
    return (
		<Modal show={true}>
		<Modal.Window>
			<Modal.Window.Header>
				<Modal.Window.Header.Title>Delete/Remove Object</Modal.Window.Header.Title>
				<Modal.Window.Header.CloseButton onClick={trashcanModalProps.onClose}>
					<XFilledIcon size='small' />
				</Modal.Window.Header.CloseButton>
			</Modal.Window.Header>
			<Modal.Window.Footer>
				<Grid variant="2-up">
					<Grid.Item>
						<Button variant="primary" color="accent" onClick={trashcanModalProps.onDelete} disabled={trashcanModalProps.deleteNew}>
							Mark to DELETE
						</Button>
					</Grid.Item>
					<Grid.Item>
						<Button variant="secondary" onClick={trashcanModalProps.onRemove}>
							Remove from list
						</Button>
					</Grid.Item>
				</Grid>
			</Modal.Window.Footer>
		</Modal.Window>
	</Modal>
    );
}

export default TrashcanModal;